<template lang='pug'>
  transition(name='slide')
    .mobile-filters(v-if='showMobileFilter')
      .mobile-header.row
        .col-3.header-action(@click='showOverlay ? filterBack() : closeFilter()')
          .svg-icon(:class='showOverlay ? "chevron-left" : "close"')
        .col-6
          h3.header-title.h3(v-text='filterText')
        .col-3.header-action
          template(v-if='isAnyFilterApplied')
            .filter-clear-btn(@click='resetCurrentFilter' v-t='"clear"' v-if='showOverlay')
            .filter-clear-btn(@click='resetAllFilters' v-t='$t(`products.reviews.clearAll`)' v-else)

      .filter-list
        .card.card-light.filter-card.filter-select(v-for='(filter, index) in filterList' :key='index')
          a(@click.prevent='setCurrentFilterPage(filter.type)')
            span.h4.filter-page-title(v-text='filter.label')
            span.selected-option-count(v-if='selectedOptionsCount(filter.type) > 0' v-text='selectedOptionsCount(filter.type)')
            .svg-icon.chevron-right.slide-arrow

          transition(name='slide')
            .overlay(v-if='currentFilterType === productOptionType')
              .card.card-light.filter-card.form-check.select-all-check
                a.filter-option.form-check-label(:class='{ "active": isAllVariantsSelected }')
                  span(v-t='viewAllText')
                  input.form-check-input.form-svg.checkbox-input(type='checkbox' v-model='isAllVariantsSelected' @change='setSelectedVariants')
              .card.card-light.filter-card.form-check(v-for='variant in variants' :key='variant.id')
                a.filter-option.form-check-label(:class='{ "active": isSelectedVariant(variant.id) }')
                  span(v-t='variant.attributes["name"]')
                  input.form-check-input.form-svg.checkbox-input(type='checkbox' :value='variant.id' v-model='selectedVariants')

            .overlay(v-if='currentFilterType === "country"')
              .card.card-light.filter-card.form-check.select-all-check
                a.filter-option.form-check-label(:class='{ "active": isAllCountriesSelected }')
                  span(v-t='viewAllText')
                  input.form-check-input.form-svg.checkbox-input(type='checkbox' v-model='isAllCountriesSelected' @change='setSelectedCountries')
              .card.card-light.filter-card.form-check(v-for='(countryName, countryCode) in reviewMeta.countries' :key='countryCode')
                a.filter-option.form-check-label(:class='{ "active": isSelectedCountry(countryCode) }')
                  span(v-text='$t(`products.reviews.countryName.${countryCode}`)')
                  input.form-check-input.form-svg.checkbox-input(type='checkbox' :value='countryCode' v-model='selectedCountries')

            .overlay(v-if='currentFilterType === "rating"')
              .card.card-light.filter-card.form-check.select-all-check
                a.filter-option.form-check-label(:class='{ "active": isAllRatingsSelected }')
                  span(v-t='viewAllText')
                  input.form-check-input.form-svg.checkbox-input(type='checkbox' v-model='isAllRatingsSelected' @change='setSelectedRatings')
              .card.card-light.filter-card.form-check(v-for='rating in reviewMeta["rating-distribution"]' :key='rating["rating-value"]')
                a.filter-option.form-check-label(:class='{ "active": isSelectedRating(rating["rating-value"]) }')
                  .rating-container
                    ProductRatingStars(:rating='rating["rating-value"]')
                    span.review-count ({{ rating.count }})
                    input.form-check-input.form-svg.checkbox-input(type='checkbox' :value='rating["rating-value"]' v-model='selectedRatings')

      .mobile-filter-actions
        button.btn.btn-lg.btn-block(@click='filterApply' v-t='"viewAllResults"')
</template>

<i18n>
{
  "lng_en": {
    "viewAllResults": "View All Results",
    "selectAllShade": "Select All Shade",
    "selectAllType": "Select All Type",
    "selectAllSize": "Select All Size",
    "selectAllCountry": "Select All Country/Region",
    "selectAllRating": "Select All Rating",
    "clear": "Clear"
  },
  "lng_id": {
    "viewAllResults": "Lihat Semua Hasil",
    "selectAllShade": "Pilih Semua Bayangan",
    "selectAllType": "Pilih Semua Tipe",
    "selectAllSize": "Pilih Semua Ukuran",
    "selectAllCountry": "Pilih semua Negara/Wilayah",
    "selectAllRating": "Pilih semua peringkat",
    "clear": "jernih"
  },
  "lng_th": {
    "viewAllResults": "ดูผลลัพธ์ทั้งหมด",
    "selectAllShade": "เลือกเฉดสีทั้งหมด",
    "selectAllType": "เลือกทุกประเภท",
    "selectAllSize": "เลือกทุกขนาด",
    "selectAllCountry": "เลือกทั้งหมด ประเทศ/ภูมิภาค",
    "selectAllRating": "เลือกการให้คะแนนทั้งหมด",
    "clear": "ชัดเจน"
  },
  "lng_zh": {
    "viewAllResults": "查看所有結果",
    "selectAllShade": "選擇所有陰影",
    "selectAllType": "選擇所有種類",
    "selectAllSize": "選擇所有大小",
    "selectAllCountry": "選擇全部國家/地區",
    "selectAllRating": "選擇所有評級",
    "clear": "清除"
  },
  "lng_ko": {
    "viewAllResults": "모든 결과 보기",
    "selectAllShade": "모든 음영 선택",
    "selectAllType": "모든 타입 선택",
    "selectAllSize": "모든 사이즈 선택",
    "selectAllCountry": "모든 국가/지역",
    "selectAllRating": "모든 평가 선택",
    "clear": "지우기"
  }
}
</i18n>

<script>
import { mapState, mapGetters } from 'vuex'
import capitalize from 'lodash/capitalize'
import ProductRatingStars from '@/components/products/product-rating-stars.vue'
import { pushDataLayerEvent } from '@/modules/services/gtm'

export default {
  components: {
    ProductRatingStars
  },

  props: {
    variants: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      currentFilterType: '',
      showOverlay: false,
      isAllVariantsSelected: false,
      selectedVariants: [],
      isAllCountriesSelected: false,
      selectedCountries: [],
      isAllRatingsSelected: false,
      selectedRatings: [],
      filterSources: {
        selectedVariants: [],
        selectedCountries: [],
        selectedRatings: []
      }
    }
  },

  computed: {
    ...mapState({
      showMobileFilter: state => state.review.showMobileFilter,
      reviewMeta: state => state.review.meta,
      product: state => state.product.product
    }),

    ...mapGetters([
      'productOptionType'
    ]),

    selectedVariantsCount () {
      return this.selectedVariants.length
    },

    selectedCountriesCount () {
      return this.selectedCountries.length
    },

    selectedRatingsCount () {
      return this.selectedRatings.length
    },

    currentFilterList () {
      return this.filterList.find(filter => filter.type === this.currentFilterType)?.list
    },

    filterList () {
      return [
        {
          type: 'country',
          label: this.$t(`products.reviews.country`),
          list: Object.keys(this.reviewMeta.countries)
        },
        {
          type: 'rating',
          label: this.$t(`products.reviews.rating`),
          list: this.reversedRatingDistribution()
        },
        {
          type: this.productOptionType,
          label: this.$t(`products.reviews.${this.productOptionType}`),
          list: this.variants
        }
      ]
    },

    filterText () {
      if (this.currentFilterType) {
        return this.filterList.find(filter => filter.type === this.currentFilterType).label
      }

      return this.$t('products.reviews.filter')
    },

    viewAllText () {
      return this.$t(`selectAll${capitalize(this.currentFilterType)}`)
    },

    isAnyFilterApplied () {
      const filtersSelectedOptions = this.filtersSelectedOptions()
      if (this.currentFilterType) {
        return this[filtersSelectedOptions[this.currentFilterType]].length > 0
      }
      return Object.values(filtersSelectedOptions).some(filtersOption => this[filtersOption].length > 0)
    }
  },

  watch: {
    selectedVariants () {
      this.isAllVariantsSelected = this.isAllSelected('Variants')
    },

    selectedCountries () {
      this.isAllCountriesSelected = this.isAllSelected('Countries')
    },

    selectedRatings () {
      this.isAllRatingsSelected = this.isAllSelected('Ratings')
    }
  },

  methods: {
    closeFilter () {
      this.clearFilterHistory()
      this.filterUndo()
      this.$emit('updateAppliedFiltersCount', this.appliedFiltersCount())
      this.$store.commit('setShowMobileFilter', false)
    },

    filterUndo () {
      const filterTypes = ['Variants', 'Countries', 'Ratings']

      filterTypes.forEach(filterType => {
        const selectedValues = `selected${filterType}`

        if (JSON.stringify(this[selectedValues]) !== JSON.stringify(this.filterSources[selectedValues])) {
          this[selectedValues] = this.filterSources[selectedValues]
        }
      })
    },

    isAllSelected (filterType) {
      if (this.currentFilterType) {
        return this[`selected${filterType}Count`] === this.currentFilterList?.length
      }

      return this.filterSources[`isAll${filterType}Selected`] && this[`selected${filterType}`].length > 0
    },

    filterBack () {
      if (!this.showOverlay) {
        this.$store.commit('setShowMobileFilter', false)
      }
      this.clearFilterHistory()
    },

    filterApply () {
      this.setReviewsFilterByCountry()
      this.setReviewsFilterByRating()
      this.setFilterByVariantIds()
      this.$emit('filterApplied')
      this.recordAllFilterSelectionGtmEvent()
      this.filterSources = {
        selectedVariants: [...this.selectedVariants],
        selectedCountries: [...this.selectedCountries],
        selectedRatings: [...this.selectedRatings],
        isAllVariantsSelected: this.isAllVariantsSelected,
        isAllCountriesSelected: this.isAllCountriesSelected,
        isAllRatingsSelected: this.isAllRatingsSelected
      }
      this.closeFilter()
    },

    setCurrentFilterPage (filter) {
      if (filter) {
        this.currentFilterType = filter
        this.showOverlay = true
      }
    },

    reversedRatingDistribution () {
      const ratingDistribution = this.reviewMeta['rating-distribution']
      return ratingDistribution.reverse()
    },

    clearFilterHistory () {
      this.currentFilterType = ''
      this.showOverlay = false
    },

    setSelectedVariants () {
      if (this.isAllVariantsSelected) {
        this.selectedVariants = this.currentFilterList.map(variant => variant.id)
      } else {
        this.selectedVariants = []
      }
    },

    setSelectedCountries () {
      if (this.isAllCountriesSelected) {
        this.selectedCountries = Object.keys(this.reviewMeta.countries)
      } else {
        this.selectedCountries = []
      }
    },

    setSelectedRatings () {
      if (this.isAllRatingsSelected) {
        this.selectedRatings = this.currentFilterList.map(rating => rating['rating-value'])
      } else {
        this.selectedRatings = []
      }
    },

    setFilterByVariantIds () {
      const variantIds = this.isAllVariantsSelected ? [] : this.selectedVariants.join(',')
      this.$store.commit('setReviewsFilterByVariantIds', variantIds)
    },

    setReviewsFilterByCountry () {
      const countries = this.isAllCountriesSelected ? null : this.selectedCountries.join(',')
      this.$store.commit('setReviewsFilterByCountry', countries)
    },

    setReviewsFilterByRating () {
      const rating = this.isAllRatingsSelected ? null : this.selectedRatings.join(',')
      this.$store.commit('setReviewsFilterByRating', rating)
    },

    isSelectedVariant (value) {
      return this.selectedVariants.includes(value)
    },

    isSelectedCountry (value) {
      return this.selectedCountries.includes(value)
    },

    isSelectedRating (value) {
      return this.selectedRatings.includes(value)
    },

    resetAllFilters () {
      this.selectedVariants = []
      this.selectedRatings = []
      this.selectedCountries = []
    },

    resetCurrentFilter () {
      const currentFilterOptions = this.filtersSelectedOptions()[this.currentFilterType]
      if (currentFilterOptions) {
        this[currentFilterOptions] = []
      }
    },

    selectedOptionsCount (filterType) {
      return this[this.filtersSelectedOptions()[filterType]].length || 0
    },

    appliedFiltersCount () {
      const filtersOptionsList = Object.values(this.filtersSelectedOptions()).map(filtersOption => this[filtersOption])
      return filtersOptionsList.filter(filtersOption => filtersOption.length > 0).length
    },

    filtersSelectedOptions () {
      return {
        [this.productOptionType]: 'selectedVariants',
        'country': 'selectedCountries',
        'rating': 'selectedRatings'
      }
    },

    recordAllFilterSelectionGtmEvent () {
      const filterTypesMaping = {
        'Ratings': 'rating_selected',
        'Countries': 'country',
        'Variants': 'variant'
      }

      Object.entries(filterTypesMaping).forEach(([key, value]) => {
        const selectedValues = [...this[`selected${key}`]]
        if (key === 'Countries' && this.isAllCountriesSelected) selectedValues.unshift('All')
        this.recordFilterSelectionGtm(value, selectedValues)
      })
    },

    recordFilterSelectionGtm (filterType, selectedValue) {
      pushDataLayerEvent(
        'click_filter_reviews', {
          params: {
            product_id: this.product.id,
            filter_type: filterType,
            filter_value: selectedValue.join(',')
          }
        }
      )
    }
  }
}
</script>

<style lang='scss'>
  .slide-leave-active,
  .slide-enter-active {
    transition: .3s;
  }

  .slide-enter {
    transform: translate(100%, 0);
  }

  .slide-leave-to {
    transform: translate(100%, 0);
  }

  .filter-svg {
    position: absolute;
    right: 10px;
    accent-color: $black;
  }

  .checkbox-input {
    accent-color: $black;
    float: right;
  }

  .slide-arrow {
    position: absolute;
    top: 12px;
    right: 18px;
    height: 20px;
    width: 20px;
    display: inline-block;
  }

  .filter-list {
    height: 100%;
    padding-bottom: 170px;
    overflow-y: auto;

    .filter-select {
      border-bottom: 1px solid $grey;

      .selected-option-count {
        position: absolute;
        right: 45px;
        height: 24px;
        width: 32px;
        border-radius: 16px;
        text-align: center;
        color: $white;
        padding: 3px;
        background: $grey-dark;
      }
    }
  }

  .filter-card {
    border: 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    a {
      color: inherit;
      display: flex;
      padding: 14px 20px 12px;
      white-space: nowrap;
      width: 100%;
    }

    .select-all-check {
      border-bottom: 10px solid $grey-light;
      margin: 0;
    }

    .filter-page-selection {
      @include font-weight-book;
      margin-left: 15px;
      margin-right: 30px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $grey-dark;
      text-transform: capitalize;
    }

    .filter-page-title {
      line-height: inherit;
      text-transform: uppercase;
    }

    .filter-option {
      padding: 12px 24px;
      display: inline-block;
      width: 100%;

      .review-count {
        margin-left: 10px;
      }

      &.h4 {
        text-transform: uppercase;
      }

      &.active {
        @include font-weight-medium;
      }
    }
  }

  .mobile-filters {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: $zindex-fixed;
    background: $white;

    .overlay {
      width: 100%;
      height: 100%;
      padding-bottom: 100px;
      position: fixed;
      top: 60px;
      bottom: 40px;
      left: 0;
      z-index: $zindex-fixed;
      background: $white;
      overflow-y: scroll;
    }
  }
</style>

<style lang='scss' scoped>
  .mobile-header {
    background: $black;
    height: 50px;
    position: relative;
    z-index: $zindex-fixed;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: $white;

    .header-title {
      @include font-weight-bold;
      text-transform: uppercase;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    .header-action {
      height: 100%;
      display: flex;
      align-items: center;
    }

    .filter-clear-btn {
      text-transform: capitalize;
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .close {
      width: 15px;
      height: 15px;
      vertical-align: middle;
    }

    .chevron-left {
      width: 20px;
      height: 20px;
      display: inline-block;
      background-image: url('../../../assets/images/icons/chevron-left-white.svg');
    }
  }

  .mobile-filter-actions {
    position: fixed;
    bottom: 0;
    padding: 20px;
    width: 100%;
    z-index: $zindex-fixed;

    .btn-block {
      border-radius: 10px;
    }
  }
</style>
